<div *ngIf="attributions?.length" class="container-fluid contributors-section">
    <div class="container">
        <app-attributes [attributions]="attributions"></app-attributes>
    </div>
    <div class="credits" *ngIf="credits" innerHTML="{{ credits }}"></div>
</div>
